var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.currentTime))]),_c('div',{staticClass:"year"},[_c('div',{staticClass:"yyyy"},[_vm._v(_vm._s(_vm.currentYear))]),_c('div',{staticClass:"nongli"},[_vm._v(_vm._s(_vm.currengWeek))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }